module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 4a8 8 0 018 8c0 2.789-2.39 7.718-7.172 14.788a1 1 0 01-1.656 0C10.39 19.718 8 14.788 8 12a8 8 0 018-8zm2 5c-.533 0-1.2.35-2 1.05-.8-.7-1.467-1.05-2-1.05-1.273 0-2 1.05-2 2.1 0 1.283 1.333 2.917 4 4.9l.551-.42C18.851 13.785 20 12.292 20 11.1c0-1.05-.727-2.1-2-2.1z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/system/asda-map-pin-your-store.svg
// module id = 720
// module chunks = 0